import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type Props = {
    apiResult: WarehouseDataState;
};

type HandlerType = CustomHandler<WarehouseDataState, Props>;

export const setIsTrainingProductInCart: HandlerType = props => {
    props.dispatch({
        type: "Custom/WarehouseData/setIsTrainingProductInCart",
        param: props.parameter.isTrainingProductInCart,
    });
};

export const chain = [setIsTrainingProductInCart];

const setIsTrainingProductInCartHandler = createHandlerChainRunner(chain, "SetIsTrainingProductInCartHandler");
export default setIsTrainingProductInCartHandler;
